import { ActionIcon, Card, Group, Image, Stack, Text,Title, Tooltip } from "@mantine/core";
import { GameSectionData } from "@pages/ProfilePage/game_section_data.ts";
import React from "react";
import { useTranslation } from "react-i18next";
import { FaCheck,FaExternalLinkAlt, FaRegCopy } from "react-icons/fa";
import { Link } from "react-router-dom";

import classes from "./Profile.module.scss";

export const GameCard = ({ gameData }: { gameData: GameSectionData }) => {
  const { t } = useTranslation();
  const { gameConfig, profileGameData } = gameData;

  const webPlayEnabled = gameConfig.PublicWebClientConfig.AvailabilityOverrides?.Web ?? true;
  const gameLink = webPlayEnabled
    ? `/Play/${gameConfig.GameSystemName}`
    : gameConfig.PublicWebClientConfig.ExternalPlayUrl;
  const gameName = t(`game.${profileGameData.Game}`);

  const gameUid =
    // Try a few likely fields, use the first available
    (profileGameData as any).GameUid ??
    (profileGameData as any).Uid ??
    (profileGameData as any).Id ??
    "";

  const [copied, setCopied] = React.useState(false);
  const copyUid = async () => {
    if (!gameUid) return;
    try {
      await navigator.clipboard.writeText(String(gameUid));
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1500);
    } catch {
      // no-op
    }
  };

  return (
    <Card withBorder radius="md" className={classes.gameCard}>
      <Group justify="space-between" align="center" wrap="nowrap">
        {/* Left side: icon + title (horizontal) */}
        <Group align="center" gap="md" wrap="nowrap">
          <Image src={gameConfig?.PublicWebClientConfig.IconUrl} h={56} w={56} radius="md" />
          <Stack gap={2} style={{ minWidth: 0 }}>
            <Title order={3} size="h5" lineClamp={1}>
              {gameName}
            </Title>
			  <Text size="xs" c="gray">
				  {gameUid}
			  </Text>
          </Stack>
        </Group>

        {/* Right side: actions */}
        <Group align="center" gap="xs" wrap="nowrap">
          {/* Copy Game UID button */}
          {gameUid && (
            <Tooltip label={copied ? t("copied") : t("copyUid","Copy ID")}>
              <ActionIcon
                variant="subtle"
                color={copied ? "teal" : "gray"}
                aria-label={copied ? t("copied") : t("copy")}
                onClick={copyUid}
              >
                {copied ? <FaCheck /> : <FaRegCopy />}
              </ActionIcon>
            </Tooltip>
          )}


        </Group>
      </Group>
    </Card>
  );
};
